import { Link } from "react-router-dom";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-[#1E2D4A] px-4 py-6 text-xs text-slate-500 sm:px-6">
    <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
      <span>© {new Date().getFullYear()} RANGER · Community tools for Rust Console Edition</span>
      <nav className="flex gap-4">
        <Link data-testid="footer-browse" to="/browse" className="transition-colors hover:text-slate-200">Servers</Link>
        <Link data-testid="footer-privacy" to="/privacy" className="transition-colors hover:text-slate-200">Privacy</Link>
        <Link data-testid="footer-terms" to="/terms" className="transition-colors hover:text-slate-200">Terms</Link>
      </nav>
    </div>
    <p className="mx-auto mt-2 max-w-6xl text-[11px] text-slate-600">Not affiliated with or endorsed by Facepunch Studios, Double Eleven, Discord, Microsoft or Sony.</p>
  </footer>
);
